import { Message } from "element-ui";
import actions from "@/util/actions";

/**
 * @name 处理登陆身份鉴权
 * @author fansc
 * @time 2020.05.20
 */
// import { uasInit } from "../util/uas.js";
import store from "../store";
/**
 * @name 导入接口获取采购子应用注册表接口
 */
import subApps from "@/api/app-configs";
/**
 * @name 导入接口获取采购子应用注册表接口 好像没用到
 */
// import purchaseSubApps from "@/api/purchase_menu";
/**
 * @name 导入接口获取采购子应用注册表接口
 */

/**
 * @name 导入接口获取供应商子应用注册表接口
 */
// import vendorSubApps from "@/api/supplier_menu";
/**
 * @name 导入qiankun注册微应用方法
 */
import qianKunStart from "./app-register";
/**
 * @name 导入无需服务端获取的微应用  // 暂时隐藏登录应用
 */
import noAuthApps from "./app-config";

import { getStore, setStore } from "@/util/store";

import { APIGET, NEWAPIGET, getSRMToken } from "@/api/common";
import { setCookie } from "@/util/auth";
/**
 * @name 请求获取服务端子应用注册表
 */
const getAppConfigs = async () => {
  // const userInfo = getStore({ name: "userInfo" }) || {};
  // const isPurchase = userInfo.is_purchaser === "1";
  let _res = [];
  // if (!isPurchase) {
  //   getSupplierPrivilege().then(res => {
  //     res.data.forEach(item => {
  //       if(item.systemName !== '供应商管理') {
  //         let menuItem = vendorSubApps.find(sub => sub.title === item.systemName);
  //         if(menuItem) _res.push(menuItem);
  //       } else {
  //         let menuItem = vendorSubApps.find(sub => sub.title === '企业信息管理');
  //         if(menuItem) _res.unshift(menuItem);
  //       }
  //     })
  //   })
  // } else if (userInfo.user_code === "100000") {
  //   _res = purchaseSubApps; // 没用到
  // }
  // 处理菜单状态共享
  let _menu = _res;
  store.dispatch("menu/setMenu", _menu);
  /**
   * @name 启用qiankun微前端应用，已启动过用手动加载，未启动过正常注册
   */
  qianKunStart(subApps);
};

/**
 * @name 验证用户身份并注册微应用
 */
const microAppStart = async () => {
  const userInfo = getStore({ name: "userInfo" });
  const URL = window.location.href;
  const queryStr = window.location.hash.split("?")[1];
  const hashParams = new URLSearchParams(queryStr);
  const lang = hashParams.get("lang");
  console.log(hashParams, lang, URL, "langURL");
  let token = userInfo ? userInfo.access_token : null;
  let ticket = null;
  let staffToken = null;
  let code = null;
  let langNew = null;
  if (URL.includes("ticket=")) {
    ticket = URL.split("ticket=")[1].split("#/")[0];
    console.log(ticket, "ticket");
  }
  if (URL.includes("?lang=")) {
    langNew = URL.split("?lang=")[1].split("#/")[0];
    console.log(langNew, "lang");
    const LOCALE_KEY = "localeLanguage";
    if (langNew) {
      console.log(langNew,'langNew')
      actions.setGlobalState({ language: langNew, title: "", href: "" });

      store.dispatch("appstore/setLanguage", langNew);
     
      window.localStorage.setItem(LOCALE_KEY, langNew);
    }
  }
  if (URL.includes("portalToken=")) {
    staffToken = URL.split("portalToken=")[1].split("#/")[0];
    console.log("staffToken" + staffToken);
  }
  if (URL.includes("?code=")) {
    code = URL.split("?code=")[1].split("#/")[0];
    store.dispatch("app/setCode", code);
    return;
  }
  /**
   * @name 已登录状态获取服务端微应用注册表
   */
  if (token) {
    // 处理token状态共享
    store.dispatch("app/setToken", token);
    getAppConfigs();
    return;
  }
  /*
   * 员工自动登录
   * */
  if (staffToken) {
    // setCookie(staffToken);
    // 处理token状态共享
    autoLogin(staffToken);
    return;
  }
  // 新增potal跳转srm项目详情页
  if (URL.includes("sendSign=")) {
    await requestUserToken()
      .then((res) => {
        if (res.code === 200) {
          let href = URL.replace(/\.cn/g, "");
          href += `&portalToken=${res.data}`;
          console.log(href);
          window.location.href = href;
        }
      })
      .catch(() => {});
    return;
  }
  /**
   * 根据ticket 获取token
   */
  if (ticket) {
    setCookie(ticket);
    setStore({ name: "isAdmin", content: "0" });
    APIGET("/srm-client/oauth/getToken", {}).then((res) => {
      if (res && res.code === 200) {
        // eslint-disable-next-line no-debugger
        console.log("供应商信息加载成功", res);
        store.dispatch("app/setToken", res.data.access_token);
        const data = {
          name: res.data.user_name,
          token: res.data.access_token,
          ...res.data,
        };
        setStore({ name: "userInfo", content: data, type: "session" });
        getAppConfigs();
      }
    });
    return;
  }
  /**
   * @name 默认加载未登录时无需服务端获取的微应用
   */
  console.log("未授权登陆", noAuthApps);
  qianKunStart(noAuthApps);
};
// 员工自动登录
async function autoLogin(staffToken) {
  let params = { "Blade-Auth": staffToken };
  await NEWAPIGET("/srm-auth/oauth/getToken", params).then((res) => {
    if (res && res.code === 200) {
      // eslint-disable-next-line no-debugger
      debugger;
      store.dispatch("app/setToken", staffToken);
      const data = {
        ...res.data,
        name: res.data.user_name,
        token: staffToken,
        access_token: staffToken,
      };
      setStore({ name: "userInfo", content: data, type: "session" });
      getAppConfigs();
    }
  });
}
// 根据cookie中token获取SRM token
function requestUserToken() {
  let cookies = document.cookie.split(";");
  let boeType = cookies.find((c) => c.indexOf("boeType") > -1);
  let boeToken = cookies.find((c) => c.indexOf("boeToken") > -1);
  if (boeToken === undefined || boeType === undefined) {
    // this.$message.info("Portal登录已失效，请重新登录");
    Message.closeAll();
    Message({
      message: "Portal登录已失效，请重新登录",
      type: "error",
      duration: 0,
    });
    return;
  }
  boeType = boeType.split("=")[1];
  boeToken = boeToken.split("=")[1];
  return getSRMToken({ boeType: boeType, boeToken: boeToken });
}
export default microAppStart;
